import * as helper from './../../../Assets/Js/helper';
import * as Events from './Events';

let time = 5000;

export default class FakeChat {
	constructor(node) {
		this.list = node.querySelector('ul');
		this.bubbles = JSON.parse(helper.getData(document.querySelector('#information'), 'bubbles'));
		this.timeout = setTimeout(this.addMessage.bind(this), time + Math.random() * time);

		helper.addEventListener(window, Events.SHOW_NEXT_GIRL, () => {
			clearTimeout(this.timeout);
			this.timeout = setTimeout(this.addMessage.bind(this), time + Math.random() * time);
			this.clear();
		});
		helper.addEventListener(window, 'paytourClose', () => {
			clearTimeout(this.timeout);
			this.timeout = setTimeout(this.addMessage.bind(this), time + Math.random() * time);
			this.clear();
		});
		helper.addEventListener(window, Events.CREATE_SIGNUP, () => {
			clearTimeout(this.timeout);
		});
	}

	clear() {
		while(typeof this.list.childNodes[0] !== 'undefined') {
			this.list.removeChild(this.list.childNodes[0]);
		}
	}

	cleanup() {
		if (this.list.childNodes.length > 4) {
			this.list.removeChild(this.list.childNodes[0]);
		}
	}

	addMessage() {
		if (this.bubbles.length > 0) {
			let currentBubble = this.bubbles.shift();
			let node = helper.stringToHtml(`<li class="bubble comment warning">${currentBubble}</li>`);
			this.list.append(node);
			this.timeout = setTimeout(this.addMessage.bind(this), time + Math.random() * time);
		}
		this.cleanup();
	}
}
